import styled from 'styled-components'

import { Box, Button, CircleBackground, Typography } from '@corabank/arco'

export const InfoPageContent = styled(Box)`
  padding: 24px 0;
  text-align: center;

  @media screen and (max-width: 850px) {
    & {
      padding: 24px;
    }
  }
`

export const InfoPageCircle = styled(CircleBackground)`
  padding: 20px;
`

export const InfoPageTitle = styled(Typography)`
  margin: 24px auto 8px;
`

export const InfoPageButton = styled(Button)`
  margin: 24px auto;
`
